import { render, staticRenderFns } from "./ARButton.vue?vue&type=template&id=23fab190&scoped=true&"
import script from "./ARButton.vue?vue&type=script&lang=ts&"
export * from "./ARButton.vue?vue&type=script&lang=ts&"
import style0 from "./ARButton.vue?vue&type=style&index=0&id=23fab190&prod&lang=scss&scoped=true&"
import style1 from "./ARButton.vue?vue&type=style&index=1&id=23fab190&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fab190",
  null
  
)

export default component.exports